<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="item">
          <div class="label">用户ID：</div>
          <div class="value">{{ info.uid }}</div>
        </div>
        <div class="item">
          <div class="label">用户昵称：</div>
          <div class="value">{{ info.nickname }}</div>
        </div>
        <div class="item">
          <div class="label">当前身份：</div>
          <div class="value">{{ roleMap[info.role] }}</div>
        </div>
        <div class="item">
          <div class="label">运营中心名称：</div>
          <div class="value">{{ info.companyName }}</div>
        </div>
        <div class="item">
          <div class="label">联系方式：</div>
          <div class="value">{{ info.companyPhone }}</div>
        </div>
        <div class="item">
          <div class="label">地址信息：</div>
          <div class="value">
            {{ (info.address || "") + (info.house || "") }}
          </div>
        </div>
        <div class="item item2">
          <div class="label">商家图片：</div>
          <div class="value">
            <!-- <img
              class="img"
              v-for="(item, index) in info.pics"
              :src="item"
              alt=""
              :key="index"
            /> -->
            <el-image
              class="img"
              v-for="(item, index) in info.pics"
              :key="index"
              :src="item"
              fit="cover"
              :preview-src-list="info.pics"
            >
            </el-image>
          </div>
        </div>
        <div class="item">
          <div class="label">提审日期：</div>
          <div class="value">{{ info.created }}</div>
        </div>
        <div class="item">
          <div class="label">审核状态：</div>
          <div class="value">{{ statusMap[info.status] }}</div>
        </div>
      </div>
    </div>
    <div class="btn-box" v-if="info.status === 1">
      <button class="cancel-btn" @click="rejectModal">拒绝</button>
      <button class="confirm-btn" @click="handleResolve">审核通过</button>
    </div>
    <el-dialog
      title="确认驳回该订单吗？"
      width="450px"
      :visible.sync="rejectVisible"
    >
      <div class="reject-title"><span>*</span>请填写驳回理由</div>
      <div style="padding: 0 16px">
        <div class="remark-box">
          <textarea
            rows="8"
            class="remark"
            v-model="remark"
            placeholder="驳回理由"
          ></textarea>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click.native="reject()" class="cancel-btn">驳 回</el-button> -->
        <el-button @click.native="rejectVisible = false" class="cancel-btn btn"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click.native="handleReject"
          class="confirm-btn btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'balanceExamine',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '运营中心申请详情'
      },
      roleMap: {
        0: '消费者',
        1: 'VIP',
        2: '健康驿站',
        3: '社区店',
        4: '旗舰店',
        5: '运营中心',
        6: '分公司'
      },
      statusMap: {
        1: '待审核',
        2: '审核通过',
        3: '审核拒绝'
      },
      loading: 0,
      info: {},
      rejectVisible: false,
      remark: ''
    };
  },

  mounted() {
    this.id = +this.$route.query.id;
    // 获取列表
    this.getInfo();
  },
  computed: {},
  methods: {
    // 获取列表
    getInfo() {
      this.loading++;
      this.httpGet(this.$root.yyzxInfo, {
        id: this.id
      }).then(
        (res) => {
          this.loading--;
          this.info = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleResolve() {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要通过该审核吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.yyzxResolve, {
          id: this.id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getInfo();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    rejectModal() {
      this.rejectVisible = true;
    },
    handleReject() {
      this.loading++;
      this.httpPut(this.$root.yyzxReject, {
        id: this.id,
        remark: this.remark
      }).then(
        (res) => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.loading--;
          this.rejectVisible = false;
          this.getInfo();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 10px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 60px;
      border-radius: 2px;

      .item {
        flex-x(flex-start);
        word(14px, #666);
        height: 45px;

        &.item2 {
          height: auto;
        }

        .label {
          width: 150px;
          line-height: 45px;
          align-self: flex-start;
        }

        .img {
          width: 112px;
          height: 112px;
          border-radius: 4px;
          margin-right: 15px;
        }
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    // padding-bottom: 48px;
    padding: 24px 0;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }

  .reject-title {
    border-top: 1px solid #eee;
    padding: 12px 13px 0;
    word(14px, #666);

    span {
      color: #FD4545;
      display: inline-block;
      width: 15px;
    }
  }

  .remark-box {
    width: 100%;
    padding-left: 15px;
    box-sizing: border-box;
  }

  .remark {
    border: 1px solid #f1f1f1;
    width: 100%;
    margin: 12px 0;
    padding: 12px;
    box-sizing: border-box;
  }
}
</style>
